import { useRef, useEffect } from 'react';
export var usePrevious = function usePrevious(value) {
  var valueRef = useRef();
  useEffect(function () {
    valueRef.current = value;
  }, [value]);
  return valueRef.current;
};